// Real email send for workflow steps. Throws if email isn't set up so a step never shows "sent" falsely.
export async function sendWorkflowEmail(api, { to, subject, body, attachments = [], appraisalId, event }) {
  const { data } = await api.post('/email/send-bundle', {
    to: [to].flat().filter(Boolean),
    subject,
    body,
    attachments,
    appraisal_id: appraisalId || '',
    event: event || '',
  });
  if (data.status === 'logged') throw new Error('Email is not set up yet. Go to Settings → Email.');
  return data;
}

export const jobRef = (it) => [it?.appraisal_no ? `A${it.appraisal_no}` : '', it?.quote_type_ref, it?.variant_label]
  .filter(Boolean).join(' · ');

export const signOff = '\n\nThanks,\nRoofs To Remedy Ltd';
